<template>
  <div class="page">
    <v-carousel class="mb-2"
      hide-delimiters
      :value="getSelectedImageIndex"
      height="250"
      :show-arrows="false">
        <v-carousel-item v-for="(image, i) in getProductImages" :key="i">
          <v-row class="white" justify="center" no-gutters>
            <v-col align="center" cols="12">
              <v-img :src="image" width="250" height="250"></v-img>
            </v-col>
          </v-row>
        </v-carousel-item>
    </v-carousel>
    <v-row class="mx-4" justify="start" no-gutters>
      <v-col class="text-left" cols="12">
        <div class="text--secondary pt-2 light-text">
          Producto disponible
        </div>
        <div class="product-title pt-3">{{ _product.name }}</div>
        <div class="price-text pt-1">{{ getProductPrice }}</div>
        <div class="text--secondary">
          {{ getTotalQuantities }}
          <span v-if="getTotalQuantities === 1">Unidad disponible</span>
          <span v-else>Unidades disponibles</span>
        </div>
        <div>
          <v-list-item class="ml-n4 mt-2 mr-0 pr-0" @click="checkShipping">
            <v-list-item-avatar>
              <v-icon class="white grey--text text--darken-1">local_shipping</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>
                <span class="grey--text text--darken-2" v-if="shippingInfo">
                  <span class="green--text text--darken-2" v-if="shippingInfo.cost === 0">Envío gratis</span>
                  <span v-else>Envío {{currency(shippingInfo.cost)}}</span>
                </span>
                <span class="grey--text text--darken-2" v-else>Envío a nivel nacional</span>
              </v-list-item-title>
              <v-list-item-subtitle>
                <span class="grey--text text--darken-1" v-if="shippingInfo">
                  <span class="green--text text--darken-2" v-if="shippingInfo.cost === 0">Llega el {{ dateFormat(shippingInfo.delivery_date, 'D MMM YYYY') }}</span>
                  <span v-else>Llega el {{ dateFormat(shippingInfo.delivery_date, 'D MMM YYYY') }}</span>
                </span>
                <span class="grey--text text--darken-1" v-else>Envío rapido y seguro</span>
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <v-btn icon class="mr-n3">
                <v-icon color="grey">keyboard_arrow_right</v-icon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>
        </div>
        <v-form ref="form" v-model="valid">
          <div class="mt-7" v-if="!!_product.variation_theme">
            <v-select v-if="!_product.requires_formula"
              class="remove-shadow"
              v-model="variant"
              :items="_product.variants"
              item-text="name"
              :label="getProductVariantConfig.name"
              :rules="[isRequired]"
              :hint="getProductVariantConfig.hint"
              @change="changeVariant"
              solo
              flat
              return-object
              hide-details>
            </v-select>
          </div>

          <div class="mt-3">
            <v-select v-if="!_product.requires_formula"
              class="remove-shadow"
              v-model.number="quantity"
              :items="getProductQuantities"
              item-text="value"
              item-value="quantity"
              label="Cantidad"
              :rules="[isRequired, isNumeric]"
              :hint="getQuantityHint"
              :disabled="getProductQuantities.length === 0"
              solo
              flat
              hide-details>
            </v-select>
          </div>

          <div :class="!_product.requires_formula ? 'mt-4 mb-4' : ''">
            <v-btn v-if="!_product.requires_formula" class="text-none" block height="48" color="blue darken-1" elevation="0" dark @click="addToCart()">
              Añadir al carrito
            </v-btn>
            <v-btn v-else class="text-none" block height="48" color="blue darken-1" elevation="0" dark @click="selectFormula">
              Seleccionar fórmula
              <span class="text-lowercase" v-if="!!_product.variation_theme">&nbsp;y {{getProductVariantConfig.name}}</span>
            </v-btn>
          </div>
        </v-form>
      </v-col>
    </v-row>
    <v-row class="mb-10" no-gutters>
      <v-col cols="12">
        <v-card flat tile>
          <v-row class="mt-4" @click="goToRouteByName('About')" no-gutters>
            <v-col align="start" cols="12" class="px-4">
              <v-card-title  class="ml-n3 mr-n6">
                <div class="section-title-card">Información sobre la tienda</div>
                <v-spacer></v-spacer>
                <v-btn icon>
                  <v-icon>keyboard_arrow_right</v-icon>
                </v-btn>
              </v-card-title>
              <v-list class="mt-n6" two-line>
                <v-list-item-content>
                  <v-list-item-title class="payment-text">
                    <v-icon class="grey--text text--darken-1 pr-3" size="20">location_on</v-icon>
                    <span class="grey--text text--darken-2">{{ ubication.departament }}</span>
                  </v-list-item-title>
                  <v-list-item-subtitle class="text--secondary light-text pl-8">Santiago de {{ ubication.city }}</v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-content>
                  <v-list-item-title class="payment-text">
                    <v-icon class="grey--text text--darken-1 pr-3" size="20">stay_current_portrait</v-icon>
                    <span class="grey--text text--darken-2">Teléfonos</span>
                  </v-list-item-title>
                  <v-list-item-subtitle class="text--secondary light-text pl-8">{{phone.cell_phone}}, {{ phone.landline }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list>
            </v-col>
          </v-row>
          <v-row class="mt-4 pb-5" @click="goToRouteByName('Terms-and-conditions')" no-gutters>
            <v-col cols="12" align="start" class="card-border-top px-4">
              <v-card-title  class="ml-n3 mr-n6">
                <div class="section-title-card">Garantía</div>
                <v-spacer></v-spacer>
                <v-btn icon>
                  <v-icon>keyboard_arrow_right</v-icon>
                </v-btn>
              </v-card-title>

              <div class="mt-n3 payment-text pl-1">
                <span class="grey--text text--darken-2">Garantía del sitio hasta {{ daysWarranty }} dias</span>
              </div>
              <div class="pl-1 text--secondary light-text">
                Recibe el producto que esperabas o te devolvemos tu dinero
              </div>
            </v-col>
          </v-row>
          <v-row class="mt-4 pb-2" no-gutters v-if="_product.Descripcion">
            <v-col cols="12" align="start" class="card-border-top px-4">
              <div class="pl-1 mt-5 section-title">Descripción</div>
              <p class="mt-2 pl-1 text--secondary light-text">{{ _product.Descripcion }}</p>
            </v-col>
          </v-row>
          <v-row class="mt-4 pb-2" no-gutters v-if="_product.UsoCuidados">
            <v-col cols="12" align="start" class="card-border-top px-4">
              <div class="pl-1 mt-5 section-title">Detalles y cuidados</div>
              <p class="mt-2 pl-1 text--secondary light-text">{{ _product.UsoCuidados }}</p>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
    <shipping-modal ref="shipping" :totalValue="getProductMinPrice"></shipping-modal>
    <formula-modal ref="formula" @selectedFormula="addToCart"></formula-modal>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex'
import { currency, dateFormat } from '@/shared/format'
import { isRequired, isNumeric } from '@/shared/validations'
import { cloneObject } from '@/shared/clone'
import { buildFormulaData } from '@/shared/formula'
import navigationMixin from '@/mixins/navigation'
import FormulaModal from '@/components/Formula/FormulaModal'
import ShippingModal from '@/components/Shipping/ShippingModal'
import { UBICATION, PHONE, DAYS_WARRANTY } from '@/config/local-info'

export default {
  name: 'ProductDetailMobile',
  mixins: [navigationMixin],
  components: {
    ShippingModal,
    FormulaModal
  },
  data () {
    return {
      currency,
      dateFormat,
      isRequired,
      isNumeric,
      variant: null,
      quantity: 1,
      ubication: UBICATION,
      phone: PHONE,
      daysWarranty: DAYS_WARRANTY,
      valid: true
    }
  },
  computed: {
    ...mapState('product', ['_product']),
    ...mapState('shipping', ['shippingInfo']),
    ...mapGetters('product', ['getProductImages', 'getSelectedImageIndex', 'getProductPrice', 'getProductMinPrice', 'getProductVariantConfig', 'getTotalQuantities', 'getProductQuantities']),
    getQuantityHint () {
      const quantity = this.getProductQuantities.length
      if (!quantity) {
        return this.getProductVariantConfig.hint_disabled_quantity
      }

      return quantity === 1 ? quantity + ' Unidad disponible' : quantity + ' Unidades disponibles'
    }
  },
  methods: {
    ...mapMutations('product', ['setVariant']),
    checkShipping () {
      this.$refs.shipping.openModal()
    },
    selectFormula () {
      this.$refs.formula.openModal()
    },
    changeVariant (variant) {
      this.setVariant(variant)
    },
    addToCart (data = undefined) {
      if (!this.$refs.form.validate()) {
        return
      }

      const product = cloneObject(this._product)

      if (!data) {
        product.quantity = this.quantity
        product.variant = this.variant

        this.$emit('add', [product])
        return
      }

      if (data.type === 'single') {
        product.formula = buildFormulaData(data.formula.left)
        product.quantity = data.quantity.left
        product.variant = data.variant

        this.$emit('add', [product])
        return
      }

      this.addMultipleToCart(data)
    },
    addMultipleToCart (data) {
      const productLeft = cloneObject(this._product)
      const productRight = cloneObject(this._product)

      // add left eye formula
      productLeft.quantity = data.quantity.left
      productLeft.variant = data.variant
      productLeft.formula = buildFormulaData(data.formula.left)

      // add right eye formula
      productRight.quantity = data.quantity.right
      productRight.variant = data.variant
      productRight.formula = buildFormulaData(data.formula.right)

      this.$emit('add', [productLeft, productRight])
    }
  }
}
</script>

<style scoped>
  .page {
    flex: 1;
    background-color: #F5F5F5;
  }

  .page {
    flex: 1;
    background-color: #F5F5F5;
  }

  .product-title{
    font-size: 22px;
    line-height: 26px;
    color: #333333;
  }

  .light-text{
    font-size: 0.875em;
    color: #666;
    opacity: 0.7;
  }

  .price-text{
    font-size: 34px;
    color: #333333;
  }

  .section-title-card{
    font-size: 0.8em;
    color: #333333;
    font-weight: 500;
  }
</style>
